import { render, staticRenderFns } from "./purse.vue?vue&type=template&id=65ceba18&lang=pug&"
import script from "./purse.vue?vue&type=script&lang=js&"
export * from "./purse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports